module.exports = __webpack_public_path__ + "img/java.250d8474.png";